import locationIcon from "./assets/locationn.png";
import fulltimeIcon from "./assets/fulltime-icon.png";
import experienceIcon from "./assets/experience-icon.png";

const jobInfo = [
  {
    label: "Location",
    value: "Chennai",
    icon: locationIcon,
    alt: "Location Icon",
  },
  {
    label: "Job type",
    value: "Full time",
    icon: fulltimeIcon,
    alt: "Job Type Icon",
  },
  {
    label: "Experience",
    value: "Fresher",
    icon: experienceIcon,
    alt: "Experience Icon",
  },
];

const JobInformation = () => {
  return (
    <div className="bg-white p-6 rounded-2xl shadow-sm max-w-sm w-full">
      <h2 className="text-[32px] font-semibold text-[#212129] mb-6">
        Job Information
      </h2>

      <div className="space-y-4">
        {jobInfo.map((item, index) => (
          <div
            key={index}
            className="flex items-center bg-[#F9FAFB] p-4 rounded-xl"
          >
            <img
              src={item.icon}
              alt={item.alt}
              className="w-12 h-12 mr-4"
            />
            <div>
              <p className="text-[#9CA3AF] text-sm font-medium">
                {item.label}
              </p>
              <p className="text-[#111827] text-base font-semi">
                {item.value}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default JobInformation;
